import { render, staticRenderFns } from "./productos.vue?vue&type=template&id=77d50a9b&scoped=true&"
import script from "./productos.vue?vue&type=script&lang=js&"
export * from "./productos.vue?vue&type=script&lang=js&"
import style0 from "./productos.vue?vue&type=style&index=0&id=77d50a9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d50a9b",
  null
  
)

export default component.exports